import { render, staticRenderFns } from "./studentMock.vue?vue&type=template&id=622a5baf&scoped=true&"
import script from "./studentMock.vue?vue&type=script&lang=js&"
export * from "./studentMock.vue?vue&type=script&lang=js&"
import style0 from "./studentMock.vue?vue&type=style&index=0&id=622a5baf&scoped=true&lang=less&"
import style1 from "./studentMock.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622a5baf",
  null
  
)

export default component.exports